import { keepPreviousData, useQuery } from "@tanstack/react-query";
import axiosClient from "../../../services/api/axiosInstance";
import type { ModelPricing } from "../models/ModelPricing";

export const MODEL_PRICING_QUERY_KEY = "ModelPricing";

export const useModelPricing = () =>
  useQuery<ModelPricing[]>({
    queryKey: [MODEL_PRICING_QUERY_KEY],
    queryFn: async ({ signal }) => {
      const response = await axiosClient.get<ModelPricing[]>(
        "/api/v1/ai-settings/model-pricing",
        {
          signal,
        }
      );

      return response?.data;
    },
    placeholderData: keepPreviousData,
    staleTime: 60000,
  });
